import styled from 'styled-components';

export const StyledViewerTab = styled.div`
  position: absolute;
  top: 126px;
  left: 10px;
  width: 360px;

  .ant-tabs {
    border-radius: 10px;
    border: 1px solid #c1c4ce;

    .ant-tabs-nav {
      margin: 0px;
      border-radius: 10px 10px 0px 0px;
      overflow: hidden;
    }

    .ant-tabs-nav-list {
      width: 100%;

      .ant-tabs-tab {
        flex: 1;
        background-color: #c8cad2;
        border-radius: 0px;
        margin: 0px !important;
        border: none;
        justify-content: center;

        &:not(:nth-child(4)) {
          border-right: 1px solid #a8aab0;
        }

        &.ant-tabs-tab-active {
          color: #4c4d56;
          background-color: #fff;
        }

        .tab-title {
          color: #4c4d56;
          font-size: 14px;
        }
      }
    }
  }
`;
